import * as React from 'react'
import './styles.css'
// assets
import Logos from '../../../../../assets/imgs/mwm/mwm-afghanistan-logos.png'
import WomanImage from '../../../../../assets/imgs/mwm/mwm-woman-image-3.webp'

const Header = () => {
  return (
    <section className={'header-wrapper'}>
      <div className={'header-container'}>
        <img
          className={'mwm-logo'}
          src={Logos}
          alt='mwm-afghanistan-logos'
          title='mwm-afghanistan-logos'
        />
        <h3 className={'header-title'}>MWM Mentoring Hub</h3>
        <div className={'header-description'}>
          <strong className={'header-description-title'}>Mission</strong>
          <br />
          The Million Women Mentors Initiative for Afghan Women and Girls (MWMA)
          aims to catalyze commitments to mentor one million Afghan women in
          girls inside Afghanistan and countries around the world by 2027.
          Launched by U.S. Secretary of State Antony Blinken on the margins of
          the U.N. General Assembly, it is an initiative of the Alliance for
          Afghan Women’s Economic Resilience (AWER), a public-private
          partnership between the U.S. Department of State and Boston
          University.
        </div>
      </div>
      <div className={'header-container woman-image-container'}>
        <img
          className={'mwm-woman-image'}
          src={WomanImage}
          alt='mwm-afghanistan-woman'
          title='mwm-afghanistan-woman'
        />
      </div>
    </section>
  )
}

export default Header
